/** Außenabstand des Fehler-Outlines. 0 liegt auf dem Rahmen, 4 px bleibt lesbar. */
export const INTAKE_ERROR_OUTLINE_OFFSET = 4;
/** Reservierte Stärke, damit der native Fehlerrahmen den Inhalt nicht verschiebt. */
export const INTAKE_ERROR_BAND = 2;

/**
 * Nativer Fokusrahmen. In Klar hell ist inputFocusBorder gleich primary,
 * der gewählte Chip bliebe bei 1,00:1. Der Textton hält mindestens 3:1
 * gegen Füllung und Auswahlrahmen.
 */
export function intakeChipBorderColor(
  focused: boolean,
  selected: boolean,
  color: { text: string; primary: string; inputFocusBorder: string; inputBorder: string },
): string {
  if (focused && selected) return color.text;
  if (focused) return color.inputFocusBorder;
  return selected ? color.primary : color.inputBorder;
}
